var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ion-header',[_c('ion-toolbar',[_c('ion-title',[_vm._v(_vm._s(_vm.title))])],1)],1),_c('ion-content',{staticClass:"ion-padding"},[_c('pre',[_vm._v("        \n      "+_vm._s(_vm.content)+"\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }